import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Header from '../Component/Header'
import Footer from '../Component/Footer'
const SchoolTiming = () => {
  useEffect(() => {
    document.title = 'School Timing -  St Peters convent School Faridabad Haryana';
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li><Link to="/"> Home</Link> </li>
          <li>  Academics  </li>
          <li>School Timing </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>School Timing  </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div class="table-responsive maintable">
                <table class="table">
                  <thead>
                    <tr>
                      <th colspan="2">Class I - X</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td> Summer </td><td> 7:30 A.M to 1:30 P.M </td></tr>
                    <tr><td> Winter </td><td> 8:00 A.M to 2:00 P.M </td></tr>

                    <tr>
                      <td colspan="2" align="center">
                        Reporting Time 7:55 AM
                      </td>
                    </tr>

                    <tr>
                      <td colspan="2" align="center">
                        <b> The first and second Saturdays will be a Holiday. </b>
                      </td>
                    </tr>

                    <tr className="colorbg"><td colspan="2"> Kindergarten (Nur, LKG, UKG) </td></tr>
                    <tr><td> Summer </td><td> 8:30 A.M to 12:30 P.M </td></tr>
                    <tr><td> Winter </td><td> 9:00 A.M to 1:00 P.M </td></tr>
                    <tr>
                      <td colspan="2" align="center">
                        Reporting Time 8:55 AM
                      </td>
                    </tr>
                    <tr><td colspan="2" align="center"> <b>Saturday Holiday</b> </td></tr>


                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default SchoolTiming
